import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { getLanguage } from 'UTILS/getLanguage';

import styles from './TimeZone.styles.m.css';
import { getTimeZoneName } from './getTimeZoneName';

export const TimeZone: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('calendar_event_time_zone')}</div>
      <div
        className={styles.name}
        data-test={'calendar-event-time-zone-text'}
      >
        {getTimeZoneName(getLanguage())}
      </div>
    </div>
  );
};
